import { useState } from "react";

export const useAccompanyingPersons = ({ setRegistrationJustUpdated }) => {
  const [accompanyingPersons, setAccompanyingPersons] = useState([]);
  const [accompanyingPersonFee, setAccompanyingPersonFee] = useState(null);

  const handleAddAccompanyingPerson = () => {
    setAccompanyingPersons((currentPersons) => [
      ...currentPersons,
      {
        name: "",
        paid: false,
        paymentId: null,
        feeTypeId: accompanyingPersonFee?.id,
      },
    ]);
    setRegistrationJustUpdated(false);
  };

  const handleRemoveAccompanyingPerson = (index) => {
    setAccompanyingPersons((currentPersons) =>
      currentPersons.filter((_, currentIndex) => currentIndex !== index)
    );
    setRegistrationJustUpdated(false);
  };

  const handleAccompanyingPersonNameChange = (index, value) => {
    setAccompanyingPersons((currentPersons) =>
      currentPersons.map((person, currentIndex) =>
        currentIndex === index ? { ...person, name: value } : person
      )
    );
    setRegistrationJustUpdated(false);
  };

  return {
    accompanyingPersons,
    setAccompanyingPersons,
    accompanyingPersonFee,
    setAccompanyingPersonFee,
    handleAddAccompanyingPerson,
    handleRemoveAccompanyingPerson,
    handleAccompanyingPersonNameChange,
  };
};
